/** App branding / search bar. Already used by Header + ProtoAppHeader. */
export const SHELL_APP_HEADER_CLASS = 'h-12'

/** Shared column-header row under the app header (Open Tabs, tab bar, agent). */
export const SHELL_COLUMN_HEADER_CLASS = 'h-10'
/** Pixel height matching `SHELL_COLUMN_HEADER_CLASS` (`h-10`). */
export const SHELL_COLUMN_HEADER_PX = 40

/**
 * Index row: folder filter row, peek header, People title row, info-dock heading.
 * Only `ShellIndexRow` (`@/components/layout/shell`) should apply it.
 */
export const SHELL_INDEX_ROW_CLASS = 'h-11'

/**
 * Sticky band inside a scrollport. The hairline is separate: apply
 * `border-b border-border` only while `useStickyStuck` is true, so a bar
 * with content above it stays open until it pins. Gallery source:
 * `/?test=flows-studio` Pulse Activity. Hook: `useStickyStuck`.
 */
export const STICKY_INDEX_BAND_CLASS = 'sticky top-0 z-20'

/** Column headings pin one index row (h-11 / top-11) under the sticky band. */
export const STICKY_COLUMN_HEAD_CLASS =
  'sticky top-11 z-10 h-8 border-b border-border bg-background'

/** Shared column-footer row (Settings + document / list status bars). */
export const SHELL_COLUMN_FOOTER_CLASS = 'h-10'

/** Collapsed icon rail and collapsed agent strip. Inventory + ProtoIconRail. */
export const SHELL_ICON_RAIL_PX = 48
export const SHELL_ICON_RAIL_CLASS = 'w-12'

/**
 * Icon-rail mode buttons. Gallery: /?test=maater-ui#panel-collapse
 *
 * Rail fill is `bg-sidebar-accent` - do NOT use `hover:bg-sidebar-accent*` (invisible).
 * Idle hover: soft primary wash + ring (echo of active) + gentle scale.
 */
export const SHELL_ICON_RAIL_BUTTON_BASE_CLASS =
  'relative flex h-9 w-9 items-center justify-center rounded-md ' +
  'origin-center transition-[color,background-color,box-shadow,transform] duration-150 ease-out'

export const SHELL_ICON_RAIL_BUTTON_ACTIVE_CLASS =
  'bg-primary/15 text-primary ring-1 ring-primary/40'

/** Soft active echo + swell - readable on sidebar-accent rail fill. */
export const SHELL_ICON_RAIL_BUTTON_IDLE_CLASS =
  'text-sidebar-foreground/45 ' +
  'hover:scale-105 hover:bg-primary/10 hover:text-sidebar-foreground hover:ring-1 hover:ring-primary/30 ' +
  'active:scale-100'

/** Drive disconnected (and similar) - quieter idle, same hover language. */
export const SHELL_ICON_RAIL_BUTTON_DIMMED_CLASS =
  'text-sidebar-foreground/25 ' +
  'hover:scale-105 hover:bg-primary/10 hover:text-sidebar-foreground/65 hover:ring-1 hover:ring-primary/20 ' +
  'active:scale-100'

/**
 * Main tab is this limb, sidebar mode is something else.
 * Brand color + ring, not the full active wash (that mode stays the real selection).
 */
export const SHELL_ICON_RAIL_BUTTON_SUGGESTED_CLASS =
  'text-primary ring-1 ring-primary/50 ' +
  'hover:scale-105 hover:bg-primary/10 hover:ring-primary/60 ' +
  'active:scale-100'

/** Pulse an inset ring a few times, then settle on the suggested ring. */
export const SHELL_ICON_RAIL_BUTTON_SUGGESTED_PULSE_CLASS = 'rail-suggested-pulse'

/**
 * Show or hide one shell column. Gallery: /?test=maater-ui#panel-collapse
 *
 * Pressed while that column is docked. Inline sits in a column header.
 * The rail and the agent strip use the h-10 slot instead of this base size.
 */
export const SHELL_PANEL_TOGGLE_BASE_CLASS =
  'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md'

export const SHELL_PANEL_TOGGLE_PRESSED_CLASS = 'bg-primary/15 text-primary'

export const SHELL_PANEL_TOGGLE_IDLE_CLASS =
  'text-muted-foreground/70 hover:bg-muted hover:text-foreground'

